module.exports = __webpack_public_path__ + "static/media/swarm.ad1f2208.png";